import { CollapsibleDataGridLayout, List } from 'framework/list';
import { BadgeField, DateField, ListColumnTotalField, PercentField, TextField } from 'framework/ui/field';
import {
  ACTIVE_STATUS,
  AssignmentTargetLinkField,
  BenchBadge,
  PositionInAssignmentField,
  useAssignmentService,
} from 'domain/shared/assignment';
import { EmployeeLinkField, useEmployeeUrl } from 'domain/shared/employee';
import { useShowContext } from 'framework/show';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import AssignmentDurationBadge from './AssignmentDurationBadge';
import { ResourceData } from 'framework/crud';

const getPercentLabel = (totalPercent: number) => (
  <Typography variant="subtitle1" color="success">
    {totalPercent}%
  </Typography>
);

const SummaryAssignments = () => {
  const { search } = useAssignmentService();
  const { data } = useShowContext();
  const { employeeAlias } = data.getData();
  const { getEmployeeAssignmentsUrl } = useEmployeeUrl();

  const getAssignmentsDataMethod = async (params: ResourceData) => {
    return search({
      ...params,
      filter: {
        'specification:assignmentsByEmployeeAlias': { eq: employeeAlias },
        status: { in: [ACTIVE_STATUS] },
        ...params.filter,
      },
    });
  };

  return (
    <List getDataMethod={getAssignmentsDataMethod}>
      <Box
        sx={{
          '& .list-general tbody td': { border: 0, fontSize: '12px', p: 1 },
          '& .list-general th': { width: 'auto', p: 1 },
          pb: 2,
        }}
      >
        <CollapsibleDataGridLayout
          isSmallTable
          nonExpandedHeader={
            <Typography variant="h4" color="primary">
              <Link target="_blank" to={getEmployeeAssignmentsUrl(employeeAlias)}>
                Assignments
              </Link>
            </Typography>
          }
        >
          <BadgeField
            width={220}
            badges={[<BenchBadge isVisible={assignment => assignment.bench} />]}
            label={
              <Link
                style={{ fontSize: '12px', fontWeight: 'bold', color: 'primary.main' }}
                target="_blank"
                to={getEmployeeAssignmentsUrl(employeeAlias)}
              >
                Assignments
              </Link>
            }
            source="target.id"
            nameSource="target.displayName"
            typeSource="target.type"
            style={{ display: 'inline-flex' }}
          >
            <AssignmentTargetLinkField
              source="target.id"
              nameSource="target.displayName"
              typeSource="target.type"
              serviceCatalogIdSource="target.targetId"
              isOpenInNewTab
            />
          </BadgeField>
          <BadgeField width={60} badges={[<AssignmentDurationBadge endDateSource="to" />]} />
          <PercentField
            source="minPercent"
            label={<ListColumnTotalField source="minPercent" value={getPercentLabel} />}
          />
          <TextField label={<Typography color="success">-</Typography>} value="-" />
          <PercentField
            source="maxPercent"
            label={<ListColumnTotalField source="maxPercent" value={getPercentLabel} />}
          />
          <PositionInAssignmentField source="assignmentType" label="" />
          <EmployeeLinkField source="ownerId" nameSource="ownerName" label="" isOpenInNewTab />
          <DateField source="from" label=" " />
          <Typography>-</Typography>
          <DateField source="to" label=" " />
        </CollapsibleDataGridLayout>
      </Box>
    </List>
  );
};

export default SummaryAssignments;
